import { Component, ElementRef, EventEmitter, HostListener, Input, Output, QueryList, viewChild, ViewChildren } from '@angular/core';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSort } from '@angular/material/sort';
import { ViewChild, AfterViewInit } from '@angular/core';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatTableModule, MatTableDataSource } from '@angular/material/table';
import { CommonModule } from '@angular/common';
import { MatDrawer, MatSidenavModule } from '@angular/material/sidenav';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { AddPatientComponent } from '../add-patient/add-patient.component';
import { MedicalProviderListComponent } from '../medical-provider-list/medical-provider-list.component';
import { PatientBulkuploadComponent } from '../patient-bulkupload/patient-bulkupload.component';
import { RequestMedicalEvidenceComponent } from '../request-medical-evidence/request-medical-evidence.component';
import { PatientsData } from '../../models/commonmodel';
import { PatientProfileComponent } from "../patient-profile/patient-profile.component";
import { LoaderComponent } from "../shared/loader/loader.component";
import { EntityType } from '../shared/share';
import { StatusLablesComponent } from '../shared/components/status-lables/status-lables.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MemberInsurerServiceService } from '../../services/member-insurer-service.service';
import { SubmitMedicalEvidenceComponent } from '../submit-medical-evidence/submit-medical-evidence.component';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { RequestMoreDetailsComponent } from '../request-more-details/request-more-details.component';
import { FormsModule } from '@angular/forms';
import { FillExtraInfoComponent } from '../fill-extra-info/fill-extra-info.component';
import { Roles } from '@app/modules/lps-member-login/models/commonmodel';
import { AgePipe } from '@app/modules/lps-member-login/components/shared/pipes/age.pipe';
import { MemberInsurerRestService } from '../../services/member-insurer-rest.service';
import { NotificationService } from '../shared/services/notifications.service';
import { NoDataFoundComponent } from "../shared/no-data-found/no-data-found.component";
import { ViewModeToggleComponent } from '../shared/components/view-mode-toggle/view-mode-toggle.component';
import { Location } from '@angular/common';
import { TableCardViewComponent } from "../table-card-view/table-card-view.component";
import { TableListViewComponent } from "../table-list-view/table-list-view.component";

type RequestStatus = 'requested' | 'more_info_requested' | 'in_progress' | 'received';

interface StatusOption {
  value: RequestStatus;
  label: string;
}

@Component({
  selector: 'app-patient-table',
  standalone: true,
  imports: [MatFormFieldModule, MatInputModule,
    MatPaginatorModule, MatTableModule, MatSidenavModule,
    LoaderComponent,
    StatusLablesComponent, CommonModule, MatTooltipModule,
    MatIconModule, MatMenuModule, FormsModule,
    AgePipe, NoDataFoundComponent, ViewModeToggleComponent, TableCardViewComponent, TableListViewComponent],
  templateUrl: './patient-table.component.html',
  styleUrl: './patient-table.component.scss'
})
export class PatientTableComponent implements AfterViewInit {

  @ViewChild('chipList', { static: false }) chipList!: ElementRef;

  isFilterExpanded = false;

  availableStatuses: { value: string; label: string; colorClass: string }[] = [
    { value: 'ALL', label: 'All', colorClass: 'gray' },
    { value: 'OPEN', label: 'Open', colorClass: 'openBlue' },
    { value: 'REQUESTED', label: 'Requested', colorClass: 'blue' },
    { value: 'MORE_INFO_REQUESTED', label: 'Requested More Info', colorClass: 'light-yellow' },
    { value: 'INPROGRESS', label: 'In Progress', colorClass: 'in-progress' },
    { value: 'RECEIVED', label: 'Received', colorClass: 'green' }
  ];

  currentRequestFilterStatus: string = 'requested';
  isactive:boolean=false;

  toggleFilter(): void {
    this.isFilterExpanded = !this.isFilterExpanded;
    this.isactive=true;
  }

  selectStatus(value: string): void {
    if (this.currentRequestFilterStatus === value) {
      // If the same chip clicked again, clear filter
      this.currentRequestFilterStatus = '';
    } else {
      // Otherwise set to new value
      this.currentRequestFilterStatus = value;
    }
    this.applyPatientFiltersChips();
  }

  scrollChips(direction: 'left' | 'right') {
    const container = this.chipList.nativeElement;
    const scrollAmount = 100;
    container.scrollBy({ left: direction === 'left' ? -scrollAmount : scrollAmount, behavior: 'smooth' });
  }




  isSidebarExpanded = false;
  ngAfterViewInit(): void {
    this.element.nativeElement.focus();
    console.log(this.element.nativeElement)

  }

  // For indicator animation
  indicatorOffset: number = 0;
  indicatorWidth: number = 0;

  searchQuery: string = '';
  @Input() from: string = '';
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild('sideNav') sideNav!: MatDrawer;
  @ViewChild('myInput') element!:ElementRef<HTMLInputElement>;
  enumRole = Roles;
  selectedPatient: any; // You can type this more strictly if needed
  isDataLoading: boolean = false;
  enumEntityType = EntityType;
  isMobile: boolean = false;
  renderData:any[]=[];
  viewMode: 'list' | 'grid' = 'list';


  changeViewMode(mode: 'list' | 'grid') {
    this.viewMode = mode;
  }

  searchExpanded = false;

  toggleSearch() {
    this.searchExpanded = !this.searchExpanded;
    if (!this.searchExpanded) {
      this.searchQuery = '';
      this.element.nativeElement.focus()
      console.log(this.element.nativeElement)
      this.onSearch(); // reset search on close
    }
  }

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  dataSource = new MatTableDataSource<PatientsData>([]);
  pageSize = 10;
  pageIndex = 0;

  constructor(private location: Location, private notificationService: NotificationService, private restService: MemberInsurerRestService, private memberService: MemberInsurerServiceService, private dialog: MatDialog, public MemberInsurerServiceService: MemberInsurerServiceService) {

  }

  onSearch() {
    const query = this.searchQuery.trim().toLowerCase();
    if (!query) {
      this.dataSource.data = this.patientsList; // Reset to full list if search is empty
      return;
    }
    this.dataSource.data = this.patientsList.filter(row =>
      Object.values(row).some(val =>
        val && val.toString().toLowerCase().includes(query)
      )
    );
  }

  openPatientProfile(row: any): void {
    this.selectedPatient = row;
    this.memberService.setSelectedPatient(row);
    const dialogConfig = new MatDialogConfig()
    dialogConfig.width = '800px';
    dialogConfig.height = '600px';
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = false;
    dialogConfig.enterAnimationDuration = 200;
    dialogConfig.data = row;
    const dialogRef = this.dialog.open(PatientProfileComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(confirm => {
      if (confirm) {

      }
    });
  }

  patientsList: PatientsData[] = [];
  patientsListTemp: PatientsData[] = [];
  cardSelected: any;
  patientIdSelected: any;

  displayedColumns: string[] = [
    'Applicants',
    'Phone',
    'requestedOn',
    'updatedon',
    'status',
    'provider',
    'turnaroundtime'
  ];

  columnDisplayNames: string[] = [
    'Applicants',
    'Phone',
    'Requested On',
    'Status',
    'Provider',
    'Updated On',
    'Turn Around Time'
  ];

  selectedTab: number = 0;
  allProviders: any[] = [];
  filteredAgentsList: any[] = [];
  filteredProviderList: any[] = [];

  ngOnInit() {
    this.dataSource.sort = this.sort;
    
    //on dashboard card click
    const state: any = this.location.getState();
    const index = state?.index;

    const patientId = state?.id;
    this.patientIdSelected = patientId;

    const statusList = ['REQUESTED', 'MORE_INFO_REQUESTED', 'RECEIVED'];
    this.cardSelected = statusList[index] || null;

    this.memberService.sidebarExpanded$.subscribe((expanded) => {
      if (expanded) {
        this.isSidebarExpanded = false;
      } else {
        this.isSidebarExpanded = true;
      }
    });

    this.memberService.refreshDashboard$.subscribe(() => {
      this.getMemberList();
      this.dataSource.paginator = this.paginator;
    });

    this.isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    this.viewMode = this.isMobile ? 'grid' : 'list';

    this.dataSource.data = this.patientsList; // Initialize here

    this.getMemberList();

    this.dataSource.paginator = this.paginator;
  }

  applyPatientFilter() {
    if (this.cardSelected) {
      this.patientsList = this.patientsListTemp.filter(x => x.serviceRequest?.status === this.cardSelected);
    } else if (this.patientIdSelected) {
      this.patientsList = this.patientsListTemp.filter(x => x.firstName === this.patientIdSelected);
    } else {
      this.patientsList = [...this.patientsListTemp]; // clone for safety
    }
    // Update data source for UI
    this.dataSource.data = this.patientsList;
  }

  applyPatientFiltersChips() {
    if (this.currentRequestFilterStatus && this.currentRequestFilterStatus != 'ALL') {

      if (this.currentRequestFilterStatus == 'OPEN'){
        this.patientsList = this.patientsListTemp.filter(x => x?.status === this.currentRequestFilterStatus);
        this.renderData=this.patientsListTemp.filter(x => x?.status === this.currentRequestFilterStatus);
        
      }
      
      else
        this.patientsList = this.patientsListTemp.filter(x => x.serviceRequest?.status === this.currentRequestFilterStatus);
              this.renderData = this.patientsListTemp.filter(x => x.serviceRequest?.status === this.currentRequestFilterStatus);

      

    }
    else {
      this.patientsList = [...this.patientsListTemp]; 
      this.renderData=[...this.patientsListTemp]// clone for safety
    }
    this.dataSource.data = this.patientsList;
    this.renderData=this.patientsList;
    console.log(this.dataSource.data)
  }

  clearFilters() {
    this.cardSelected = undefined;
    this.patientIdSelected = undefined;
    this.applyPatientFilter();  // will reset patientsList and update dataSource
  }


  getMemberList() {
    this.isDataLoading = true;
    const id = this.memberService.getLoginUserId();

    this.restService.getAllMemberList(id).subscribe({
      next: (response) => {
        if (response.length > 0) {
          response = response
            .filter((member: { createdon: any }) => member.createdon)
            .sort((a: { createdon: string | number | Date }, b: { createdon: string | number | Date }) =>
              new Date(b.createdon).getTime() - new Date(a.createdon).getTime()
            );

          const flattenedPatients = [];

          for (const patient of response) {
            if (patient.serviceRequest?.length) {
              patient.serviceRequest.forEach((req: any) => {
                if (req.status === 'MORE_INFO_REQUESTED') {
                  patient.notificationStatus = true;
                  req.notificationStatus = true;
                }

                flattenedPatients.push({
                  ...patient,
                  serviceRequest: req
                });
              });
            } else {
              // No service requests, push as is
              flattenedPatients.push({ ...patient, serviceRequest: null });
            }
          }

          this.patientsList = flattenedPatients;
          this.renderData=this.patientsList;
          this.patientsListTemp = this.patientsList;

          if (this.cardSelected || this.patientIdSelected) {
            this.applyPatientFilter();
          }

          this.dataSource.data = this.patientsList;
          this.renderData=this.patientsList;
        }

        this.isDataLoading = false;
        this.dataSource.paginator = this.paginator;
      },
      error: () => {
        this.isDataLoading = false;
      }
    });
  }

  getTurnAroundTime = (row: any): string => {
    if (!row.serviceRequest) {
      return '';
    }
    const createdOn = new Date(row.serviceRequest.createdon);
    const now = new Date();
    if (row.serviceRequest.status?.toLowerCase() !== 'received') {
      return this.formatDuration(createdOn, now);
    } else {
      const lastUpdatedOn = new Date(row.serviceRequest.lastupdatedon);
      return this.formatDuration(createdOn, lastUpdatedOn);
    }
  }

  private formatDuration(start: Date, end: Date): string {
    let msDiff = end.getTime() - start.getTime();

    if (msDiff < 0) {
      msDiff = 0;
    }

    let totalMinutes = Math.floor(msDiff / (1000 * 60));

    const years = Math.floor(totalMinutes / (60 * 24 * 365));
    totalMinutes -= years * 60 * 24 * 365;

    const months = Math.floor(totalMinutes / (60 * 24 * 30));
    totalMinutes -= months * 60 * 24 * 30;

    const weeks = Math.floor(totalMinutes / (60 * 24 * 7));
    totalMinutes -= weeks * 60 * 24 * 7;

    const days = Math.floor(totalMinutes / (60 * 24));
    totalMinutes -= days * 60 * 24;

    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;

    const parts = [];

    if (years) parts.push(`${years}y`);
    if (months) parts.push(`${months}m`);
    if (weeks) parts.push(`${weeks}w`);
    if (days) parts.push(`${days}d`);
    if (hours) parts.push(`${hours}hrs`);
    if (minutes || parts.length === 0) parts.push(`${minutes}m`);

    return parts.join(' ');
  }



  getStatusFromRequests(requests: any[]): string {
    const priorityOrder = [
      'REJECTED',
      'MORE_INFO_REQUESTED',
      'REQUESTED',
      'RECEIVED',
      'OPEN'
    ];

    for (const status of priorityOrder) {
      if (requests.some(req => req.status === status)) {
        return status;
      }
    }

    return 'OPEN'; // default if none match
  }



  @Output() closeDrawer = new EventEmitter<void>();
  onCloseDrawer() {
    this.closeDrawer.emit();
  }

  openBulkUploadModal() {
    const dialogConfig = new MatDialogConfig()
    dialogConfig.width = '900px';
    // dialogConfig.height = '500px';
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = false;
    dialogConfig.enterAnimationDuration = 200;
    const dialogRef = this.dialog.open(PatientBulkuploadComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(confirm => {
      if (confirm) {

      }
    });
  }

  openAddMedicalProviderModal() {
    const dialogConfig = new MatDialogConfig()
    dialogConfig.width = '700px';
    dialogConfig.height = '600px';
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = false;
    dialogConfig.enterAnimationDuration = 200;
    const dialogRef = this.dialog.open(MedicalProviderListComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(confirm => {
      if (confirm) {

      }
    });
  }

  openMedicalEvidence(row: any) {
    const dialogConfig = new MatDialogConfig()
    dialogConfig.width = '700px';
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = false;
    dialogConfig.enterAnimationDuration = 200;
    dialogConfig.data = {
      memberId: row.patientId
    }
    const dialogRef = this.dialog.open(SubmitMedicalEvidenceComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(confirm => {
      if (confirm) {

      }
    });
  }

  onRequestMoreDetails(row: any) {
    const dialogConfig = new MatDialogConfig()
    dialogConfig.width = '700px';
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = false;
    dialogConfig.enterAnimationDuration = 200;
    dialogConfig.data = {
      memberId: row.patientId, fullName: row.firstName + row.lastName, gender: row.gender, date: row.dateOfBirth, email: row.email, phone: row.phone, servicerequestid: row.serviceRequests[0].id
    }
    console.log(row.serviceRequests[0].id)
    const dialogRef = this.dialog.open(RequestMoreDetailsComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(confirm => {
      if (confirm) {

      }
    });
  }

  openAddPatientModal(row: any) {
    const dialogConfig = new MatDialogConfig()
    dialogConfig.width = '900px';
    dialogConfig.height = '600px';
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = false;
    dialogConfig.enterAnimationDuration = 200;
    // dialogConfig.data = {
    //   memberId: row.patientId
    // }by yashwanth
    dialogConfig.data = row;
    const dialogRef = this.dialog.open(AddPatientComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(confirm => {
      if (confirm) {
        this.getMemberList();
      }
    });
  }

  isRotating = false;

  onRefresh() {
    this.isRotating = true;
    if(this.isFilterExpanded===true){
      this.isFilterExpanded=false;
      
    }
    this.getMemberList();

    // Stop animation after 1s (match CSS animation duration)
    setTimeout(() => {
      this.isRotating = false;
    }, 500);
  }

  openRequestME(row: any) {
    console.log("camerow")
    const dialogConfig = new MatDialogConfig()
    dialogConfig.width = '900px';
    dialogConfig.height = '600px';
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = false;
    dialogConfig.enterAnimationDuration = 200;
    dialogConfig.data = {
      memberId: row.patientId
    }
    const dialogRef = this.dialog.open(RequestMedicalEvidenceComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(confirm => {
      if (confirm) {

      }
    });
  }

  onFillMoreInfo(row: any) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = '700px';
    dialogConfig.height = '630px';
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = false;
    dialogConfig.data = row;
    const dialogRef = this.dialog.open(FillExtraInfoComponent, dialogConfig);

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        // Handle any actions after the image viewer is closed
      }
    });
  }

  onViewDocuments(doc: any) {
    console.log('doc', doc);

    // Use actual document path and name
    const fileUrl = doc.documentPath;
    const fileName = doc.documentOriginalName || doc.documentName;

    // Generate viewer URL
    const url = `/#/viewer?file=${encodeURIComponent(fileUrl)}&name=${encodeURIComponent(fileName)}`;

    // Open in new tab
    window.open(url, '_blank');
  }

  get paginatedCardData(): PatientsData[] {
    const start = this.pageIndex * this.pageSize;
    return this.renderData.slice(start, start + this.pageSize);
  }

  onPageChange(event: any) {
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;
  }

}
